<template>
  <div class="container-fluid py-6 py-md-8 image-bg -marble_bg" id="intro">
    <div class="container">
      <h1 class="text-center">Financial Advisory &amp; Asset Management</h1>
      <h2 class="subhead gold-text text-center">
        Leading Independent Industry Experts
      </h2>
      <hr />
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-xl-8">
          <p>
            Founded in 1999, CS Capital Advisors provides independent financial
            advisory and value-add asset management services to the healthcare
            and commercial real estate industries and related service sectors.
            With a proven long-term track record and unparalleled industry
            experience, CSCA is the trusted partner to assist owners, operators
            and investors in achieving their objectives and maximizing value.
          </p>
          <p>
            We distinguish ourselves by our willingness to take on challenging
            assignments, our history of producing creative solutions to complex
            situations and our commitment to provide clients with unbiased
            practical advice. Our independent platform enables us to focus our
            efforts solely on serving the needs of our clients.
          </p>
        </div>
      </div>
      <CSCAstats />
    </div>
  </div>
</template>

<script>
import CSCAstats from "@/components/CSCAstats.vue";
export default {
  components: {
    CSCAstats
  }
};
</script>

<style lang="scss" scoped>
hr {
  width: 80%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  margin-bottom: 2.5rem;
}
h2 {
  margin-bottom: 0;
}
</style>
